import { Modal } from "react-bootstrap"
import { useIntl } from "react-intl"

export const ModalInfo = ({
  show,
  onHide,
}: {
  show: any
  onHide: any
}) => {
  const intl = useIntl()
  const limitDate = new Date(2026, 1, 13, 14, 0, 0);
  const now = new Date();
  const showNewPromoImage = now >= limitDate;
  return <Modal
    show={show ? true : false}
    onHide={onHide}
    dialogClassName='modal-dialog modal-dialog-centered modal-lg'
  >
    <Modal.Header closeButton>
      <h2 className='text-black'>
        {intl.formatMessage({ id: 'INFO_MODAL.TITLE' })}
      </h2>
    </Modal.Header>
    <Modal.Body className='modal-body py-lg-10 px-lg-20'>
      {showNewPromoImage ? <>
        {intl.locale === 'es' && <img src={`/media/orders/New-Promo-ES.png`} className='d-block w-100' style={{ objectFit: 'cover', height: 'auto' }} />}
        {intl.locale !== 'es' && <img src={`/media/orders/New-Promo-EN.png`} className='d-block w-100' style={{ objectFit: 'cover', height: 'auto' }} />}
      </> : <>
        {<h3 className="mb-5 fs-1">
          {intl.formatMessage({ id: 'INFO_MODAL.CONTENT' })}
        </h3>}
        <img src={`/media/orders/info-modal-img.png`} className='d-block w-100' style={{ objectFit: 'cover', height: '500px' }} />
      </>}
    </Modal.Body>
  </Modal>
}